import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import {
  GenericError,
  LoadClientSettings,
  LoadClientSettingsSuccess,
  LoadCurrencies,
  LoadCurrenciesSuccess
} from '../actions/settings.actions';
import { APIService } from 'src/app/core/api/general.service';

@Injectable()
export class SettingsEffects {
  constructor(private actions$: Actions, private api: APIService) {}

  LoadClientSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadClientSettings),
      switchMap((payload) =>
        this.api.getAgencySettings(payload?.agencyId).pipe(
          mergeMap(
            (response) =>
              response.status === 200 && [LoadClientSettingsSuccess({ settings: response.body })]
          ),
          catchError((response) => {
            return of(GenericError({ error: response.error }));
          })
        )
      )
    )
  );

  Currencies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadCurrencies),
      mergeMap(() =>
        this.api.getCurrencies().pipe(
          mergeMap((response) => {
            const currencies = response.body.map((parameter) => parameter.parameter);
            return [LoadCurrenciesSuccess({ currencies })];
          }),
          catchError((response) =>
            of(
              GenericError({
                error: response.error
              })
            )
          )
        )
      )
    )
  );
}
